import React from 'react'
import { Text } from 'recharts'
import NumberFormat from 'react-number-format'
import styled from 'styled-components'

const Container = styled.div`
  font-size: 14px;
`

export default ({ theme, payload: { value }, ...rest }) => (
  <NumberFormat
    value={value}
    displayType='text'
    thousandSeparator
    prefix='$'
    renderText={(formattedValue) => (
      <Container as={Text} {...rest} fill={theme.colors.grey1}>
        {formattedValue}
      </Container>
    )}
  />
)
